import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import BasicInformation from "./BasicInformation";
import { SignUpAPI, WeighmentIndicatorsAPI } from "api";
import { customSettings } from "utils/customConfig";
import { toast } from "react-toastify";
import PageTitle from "utils/PageTitle";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";

const schema = yup
  .object({
    customer: yup.string(),
    product: yup.string(),
    variant: yup.string(), // optional
    // .typeError("Quantity must be a number")
    // .integer("Quantity must be an integer")
    // .min(1, "Quantity must be at least 1")
    // .required("Quantity is required"),
    addedAt: yup.date(),
    // .typeError("Added At must be a valid date")
    // .required("Added At is required"),
  })
  .required();

const AddWishlist = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const { handleSubmit, reset, setValue } = methods;

  const onSubmit = async (data) => {
    let myData = {
      ...data,
      id: location?.state?.id ?? 0, // Use nullish coalescing to handle undefined or null
    };

    // console.log(myData);

    // try {
    //   if (location?.state) {
    //     setLoading(true);
    //     await WeighmentIndicatorsAPI.post(myData);
    //     setLoading(false);
    //     toast.success("Weighment Indicator Updated Successfully", {
    //       position: customSettings.toastPosition,
    //       autoClose: customSettings.toastClose,
    //     });
    //   } else {
    //     setLoading(true);
    //     await WeighmentIndicatorsAPI.post(myData);
    //     setLoading(false);
    //     toast.success("Weighment Indicator Created Successfully", {
    //       position: customSettings.toastPosition,
    //       autoClose: customSettings.toastClose,
    //     });
    //   }

    //   // ------- Get all object keys form data and set empty values to reset ------------
    //   const keys = Object.keys(data);
    //   for (const key of keys) {
    //     submittedValues[key] = "";
    //   }
    //   reset({ ...submittedValues });
    //   navigate(-1);
    // } catch (error) {
    //   toast.error("Something Went Wrong", {
    //     position: customSettings.toastPosition,
    //     autoClose: customSettings.toastClose,
    //   });
    //   console.log(error);
    // }
  };

  useEffect(() => {
    if (location?.state) {
      reset(location.state);
    }
  }, [setValue]);

  return (
    <>
      <PageTitle name="E Commerce | Wishlists" />
      {/* <div className="py-2">
        <BreadCrumb />
      </div> */}
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Card>
            <Card.Header className="border-bottom">
              <Row className="flex-between-center ">
                <Col md>
                  {/* <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
                    {" "}
                    E Commerce | Wishlists
                  </h5> */}
                  <BreadCrumbTable title="E Commerce" subTitle="Wishlists" />
                </Col>
                <Col xs="auto">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit" disabled={loading}>
                    Ok
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <BasicInformation />
          </Card>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddWishlist;
